module.exports = __webpack_public_path__ + "static/revolution-accomplished-detail1_700px-aaf280b8711c2424ea3815a2fc887473.jpg";